import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PasswordSignatureProvider } from './password.signature-provider';
import { SignatureRequest, SignatureStatus, Certificate, SignatureProviderType } from '../signature.objects';
import { SignatureAuthorizationResponse } from './authenticated.signature-provider';
import { TranslateService } from '@ngx-translate/core';
import { WaitLoadingService } from '../../../app/components/common/waitLoading/wait-loading.service';
import { UserService } from '../../../app/user.service';
import { PlycaDataService } from '../../plyca.service';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { FileDetailsDTO } from '../../../app/api/plyca-dtos';
import { Configuration } from '../../../app/conf/app.constants';
import { SignatureUtils } from '../../signature.utils';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';

@Injectable({
  providedIn: 'root'
})
export class MockSignatureProvider extends PasswordSignatureProvider {

  constructor(protected configuration: Configuration, plycaService: PlycaDataService, translateService: TranslateService,
    userService: UserService, dialogService: DialogService, waitService: WaitLoadingService, signatureUtils: SignatureUtils
    , plycaErrorHandler: PlycaErrorHandler) {

    super(plycaService, translateService, userService, dialogService, waitService, signatureUtils, plycaErrorHandler, configuration);
  }

  public basicAutentication(user: string, password: string): Observable<SignatureAuthorizationResponse> {
    const auth = new SignatureAuthorizationResponse();
    auth.status = SignatureStatus.OK;
    auth.authorization = {
      user: user,
      password: password
    };
    return of(auth);
  }

  protected signInternal(request: SignatureRequest, authorization: any): Observable<FileDetailsDTO> {
    const fileItem = new FileDetailsDTO();
    fileItem.identifier = '163394';
    return of(fileItem);
  }

  public getCertificateList(): Observable<Certificate[]> {
    const certificates = new Array<Certificate>();
    let certificate = new Certificate();
    certificate.identifier = 'test';
    certificate.certificateB64 = 'ABC==';
    certificate.subject = 'Fernando Uribe López';
    certificate.issuer = 'FNMT Clase 2 CA';
    certificate.validFrom = new Date();
    certificate.validTo = new Date();
    certificates.push(certificate);
    certificate = new Certificate();
    certificate.identifier = 'test2';
    certificate.certificateB64 = 'ABC==';
    certificate.subject = 'Juan García García';
    certificate.issuer = 'FNMT Clase 2 CA';
    certificate.validFrom = new Date();
    certificate.validTo = new Date();
    certificates.push(certificate);
    return of(certificates);
  }

  public check(): Observable<SignatureStatus> {
    return of(SignatureStatus.OK);
  }

  protected getSignatureProviderType(): SignatureProviderType {
    return SignatureProviderType.MOCK;
  }

}
